function setCurrentToolbarClicked(el) {
    return;
}

function showUl() {
    $(this).addClass('hoverintent');
}

function hideUl() {
    $(this).removeClass('hoverintent');
    if($(this).find('.stickyBoxes__content > .component').length > 0){
        $(this).find('.stickyBoxes__content > .component').hide();
        $(this).find('.stickyBoxes__icon').removeClass('active');
    }
}

function showUlPrimary() {
    $(this).addClass('hoverintent');
    if($(this).children('ul').children('.arrow').length == 0){
        $(this).children('ul').append("<div class='arrow'></div>");
        var arrow = $(this).children('ul').children('.arrow');
        arrow.css('left',$(this).position().left + $(this).width()/2 + 'px');
    }
}

function hideUlPrimary() {
    $(this).removeClass('hoverintent');
}

function showItemlistNoExt() {
    $(this).addClass('hoverintent');
}

function hideItemlistNoExt() {
    $(this).removeClass('hoverintent');
}

function showItemlistExt() {
    var actualElem = $(this);

    if (!actualElem.parents('.random_item_list').length) {
        if (actualElem.hasClass('has_variant_pictures')) {
            var variantsWidth = actualElem.find('.itemlist_variants').outerWidth();
            actualElem.find('.itemlist_variants').css('max-height',actualElem.children('.itemlist_item').outerHeight());
            actualElem.css({
                left:  -variantsWidth,
                width: actualElem.outerWidth()+variantsWidth,
                'padding-left': variantsWidth
            });
        }else{
        }
        actualElem.addClass('hoverintent');
        actualElem.find('.itemlist_extended').show();
    }
}
function hideItemlistExt() {
    var actualElem = $(this);

    if (!actualElem.parents('.random_item_list').length) {
        if (actualElem.hasClass('has_variant_pictures')) {
            actualElem.css({
                left: '',
                width: '',
                'padding-left': ''
            });
            actualElem.find('.itemlist_variants').css('max-height','');
        }
        actualElem.find('.itemlist_extended').hide();
        actualElem.removeClass('hoverintent');
    }
}

var config = {
    over: showUl,
    timeout: 200,
    out: hideUl
};


var configPrimary = {
    over: showUlPrimary,
    timeout: 200,
    out: hideUlPrimary
};

var configItemlist = {
    over: showItemlistExt,
    timeout: 200,
    out: hideItemlistExt
};

var configItemlistNoExt = {
    over: showItemlistNoExt,
    timeout: 200,
    out: hideItemlistNoExt
};

var variant_slider_array = new Array();

var myPlayer;

function dc_checkVat(elem,value,allReverseChargeAllowedCountryCodes,currentCountryCode) {

    error = false;
    if (elem.is(':visible') && value != '' && allReverseChargeAllowedCountryCodes.length > 0
        && $.inArray(currentCountryCode, allReverseChargeAllowedCountryCodes) != -1) {
        var result = jsvat.checkVAT(value);
        if (!result.isValid) {
            elem.parent().addClass('has-danger');
            error = true;
        } else {
            elem.parent().removeClass('has-danger');
        }
    } else {
        if (elem.parent().hasClass('has-danger')) {
            elem.parent().removeClass('has-danger');
        }
    }
    return error;
}

function initScrolltopbutton (scrolltop,footer) {
    if($(window).scrollTop() > 0) {
        scrolltop.addClass('sticky');
        var scrolltopButtonBottom = scrolltop.offset().top + scrolltop.outerHeight();
        if(scrolltopButtonBottom > footer.offset().top ){
            scrolltop.css('bottom',footer.outerHeight());
        }else {
            scrolltop.css('bottom','');
        }
    }else{
        scrolltop.removeClass('sticky');
    }

    $(window).scroll(function () {
        if($(window).scrollTop() > 0) {
            scrolltop.addClass('sticky');
            var scrolltopButtonBottom = scrolltop.offset().top + scrolltop.outerHeight();
            if(scrolltopButtonBottom > footer.offset().top ){
                scrolltop.css('bottom',footer.outerHeight());
            }else {
                scrolltop.css('bottom','');
            }
        }else{
            scrolltop.removeClass('sticky');
        }
    });

    scrolltop.click(function () {
        $('html,body').animate({
            scrollTop: 0
        }, 800);
    })
}

function toggle_mobile_menu() {
    if(!$('#primary_navigation_mobile').hasClass('active')){
        show_mobile_menu();
    }else{
        hide_mobile_menu();
    }
}

function show_mobile_menu() {
    $('.modal').modal('hide');
    $('.toggle_navigation').addClass('active').attr('aria-expanded', 'true');
    $('.userlike').hide();
    $('#overlay').fadeIn('fast',function(){
        $('#primary_navigation_mobile').removeAttr('inert').animate({
            right: 0
        },200,function () {
            $('#primary_navigation_mobile').addClass('active');
            $('#primary_navigation_mobile .close_button_navigation_mobile').focus();
        });
    });
}

function hide_mobile_menu() {
    $('.userlike').show();
    $('.toggle_navigation').removeClass('active').attr('aria-expanded', 'false');
    $('#primary_navigation_mobile').animate({
        right: -340
    },200,function () {
        $('#primary_navigation_mobile').css({
            right: ''
        }).removeClass('active').attr('inert', '');
        $('#overlay').fadeOut('fast');
        $('.toggle_navigation').focus();
    });
}

function stickyHeader() {
    var mn = $('.header');
    var mns = "sticky";
    var hdr = $('.headerMain__right').position().top;
    if($(window).width() < 767) {
        hdr = 0;
    }

    checkSticky(mn, mns, hdr);

    $(window).scroll(function () {
        checkSticky(mn, mns, hdr);
    });
    $(window).resize(function () {
        var hdr = $('.headerMain__right').position().top;
        if($(window).width() < 767) {
            hdr = 0;
        }
        checkSticky(mn, mns, hdr);
    });
}

function checkSticky(mn, mns, hdr) {
    if ($(window).scrollTop() > hdr) {
        var position = mn.css('position');
        var outerHeight = mn.outerHeight();
        mn.addClass(mns);
        if (position != "fixed" && mn.prev('.sticky-helper').length < 1) {
            mn.before('<div class="sticky-helper" style="height:' + (outerHeight) + 'px"></div>');
        }
    } else {
        mn.removeClass(mns);
        $('.sticky-helper').remove();
    }
}

function initHoverintentItemlistOwl(property) {
    initHoverintentItemlist($(property.target).find('.itemlist'));
}

function initHoverintentItemlist(el) {
    var cur = el;
    //hoverintents fix touchdevices
    if (!isTouchDevice()) {
        cur.hoverIntent(configItemlist);
    } else {
        cur.click(function (event) {
            if (!$(this).hasClass('hoverintent')) {
                event.preventDefault();
                $(document).find('.hoverintent').removeClass('hoverintent');
                $(this).addClass('hoverintent');
            }
        });
    }
}

function itemsearchSuggest(searchString) {
    var data = {},
        dataDiv = $('#search_data'),
        jsonData;

    data.company = $(dataDiv).data("company");
    data.shop_code = $(dataDiv).data("shop_code");
    data.language_code = $(dataDiv).data("language_code");
    data.site_language = $(dataDiv).data("site_language");
    data.item_source = $(dataDiv).data("item_source");
    data.site_code = $(dataDiv).data("site_code");
    data.sid = $(dataDiv).data("sid");
    data.image_config = $(dataDiv).data("image_config");
    data.default_img = $(dataDiv).data("default_img");
    data.input_search = searchString;
    data.customer_no = $(dataDiv).data("customer_no");
    jsonData = JSON.stringify(data);
    $.ajax({
        type: 'POST',
        url: '/module/dcshop/b2c/ajax_itemsearch.php',
        data: jsonData,
        dataType: "json",
        converters: {
            'text json': true
        },
        beforeSend: function () {
            $('#itemsearch_suggestion_wrapper').hide().empty();
        }
    }).done(function (data) {
        console.log(data);
        $('#itemsearch_suggestion_wrapper').html(data).show(0, function () {
            var searchSuggestions = $('.search_suggestion');
            function focusSuggestion(suggestion) {
                $('.search_suggestion').removeClass('hasfocus').attr('aria-selected', 'false');
                $(suggestion).addClass('hasfocus').attr('aria-selected', 'true').focus();
            }

            function closeSearch() {
                $('#itemsearch_suggestion_wrapper').hide().empty();
                $('#input_search').focus();
            }

            $(document).on('keydown', function (e) {
                var evt = e || window.event;
                if (evt.keyCode == 38 || evt.keyCode == 40) {
                    e.preventDefault();
                    return false;
                }
            });
            $('#input_search').on('keyup', function (e) {
                var evt = e || window.event;
                if (evt.keyCode === 40 && typeof searchSuggestions !== 'undefined' && searchSuggestions.length) { //Pfeil nach unten
                    focusSuggestion($(searchSuggestions).first());
                } else if (evt.keyCode === 27) { // Escape
                    closeSearch();
                }
            });
            $('.search_suggestion').on('click', function () {
                var newHref = $(this).data('newhref');
                if (typeof newHref !== 'undefined' && newHref.length) {
                    window.location.href = newHref;
                }
            });
            $('.search_suggestion').on('keyup', function (e) {
                var newHref = $(this).data('newhref'),
                    evt = e || window.event,
                    currSuggestion = $(this),
                    currIndex = $(currSuggestion).data('suggestionindex'),
                    newIndex,
                    newSuggestion;
                if (evt.keyCode == 13 && typeof newHref !== 'undefined' && newHref.length) {
                    window.location.href = newHref;
                } else if (evt.keyCode === 27) { // Escape
                    closeSearch();
                } else if (evt.keyCode === 40 && typeof searchSuggestions !== 'undefined' && searchSuggestions.length) { //Pfeil nach unten
                    newIndex = currIndex + 1;
                    newSuggestion = $('#item_search_suggestions').find("[data-suggestionIndex='" + newIndex + "']");
                    if (typeof newSuggestion !== 'undefined' && newSuggestion.length) {
                        focusSuggestion(newSuggestion);
                    }
                } else if (evt.keyCode === 38 && typeof searchSuggestions !== 'undefined' && searchSuggestions.length) { //Pfeil nach oben
                    newIndex = currIndex - 1;
                    newSuggestion = $('#item_search_suggestions').find("[data-suggestionIndex='" + newIndex + "']");
                    if (typeof newSuggestion !== 'undefined' && newSuggestion.length) {
                        focusSuggestion(newSuggestion);
                    } else {
                        $('.search_suggestion').removeClass('hasfocus').attr('aria-selected', 'false');
                        $('#input_search').attr('aria-expanded', 'true').removeAttr('aria-activedescendant').focus();
                    }
                }
            });
        });
    }).fail(function () {
        $('#itemsearch_suggestion_wrapper').hide().empty();
    });
}

function fixRemoveEmptyCollections(){
    $('.collectionSitepart .collection_content_inner').each(function () {
        if($.trim($(this).html()) == ""){
            $(this).closest('.collectionSitepart').remove();
        }
    });
}

function showBoxContent(index) {
    $('.stickyBoxes__content > .component').hide();

    var boxcontent = $('.stickyBoxes__content > .component').eq(index);

    if(boxcontent !== undefined){
        boxcontent.show();
    }
}

function showNomamedloader () {
    $('html').css('overflow','hidden');
    $('body').css('overflow','hidden');
    $('#nomamedloader').attr('aria-busy', 'true').fadeIn('fast');
}

function hideNomamedloader () {
    $('html').css('overflow','');
    $('body').css('overflow','');
    $('#nomamedloader').fadeOut('fast', function () {
        $(this).attr('aria-busy', 'false');
    });
}

function setSrcVideos(){
    var windowWidth = $(window).width();

    $('video').each(function () {
        var video = $(this);
        var srcTablet = $(this).data('tablet-src');
        var srcMobile = $(this).data('mobile-src');
        var srcDesktop = $(this).attr('src');

        var src = srcDesktop;

        if(windowWidth < 1280 && srcTablet !== undefined){
            src = srcTablet;
        }

        if(windowWidth < 768 && srcMobile !== undefined){
            src = srcMobile;
        }

        $(this).attr('src',src);

    });
}

function fixOwlCarouselAccessibility($carousel) {
    $carousel.find('.owl-prev').removeAttr('role').attr('aria-label', 'Zurück');
    $carousel.find('.owl-next').removeAttr('role').attr('aria-label', 'Weiter');
    $carousel.find('.owl-dot').each(function (i) {
        $(this).removeAttr('role').attr('aria-label', 'Slide ' + (i + 1));
    });
    $carousel.find('.owl-nav .icon, .owl-dot .icon').attr('aria-hidden', 'true');
}

$(document).on('initialized.owl.carousel', function (e) {
    fixOwlCarouselAccessibility($(e.target));
});

function setAccessibilityLiveRegionMessage(message, type) {
    type = type || 'polite';
    var el = document.getElementById('accessibility-live-region-' + type);
    if (el) {
        el.innerText = '';
        setTimeout(function () { el.innerText = message; }, 50);
    } else {
        var fallback = document.createElement('div');
        fallback.setAttribute('aria-live', type);
        fallback.setAttribute('role', type === 'assertive' ? 'alert' : 'status');
        fallback.setAttribute('aria-atomic', 'true');
        fallback.setAttribute('style', 'position: absolute; left: -9999px; width: 1px; height: 1px; overflow: hidden;');
        fallback.innerText = message;
        document.body.prepend(fallback);
    }
    console.log('[LiveRegion][' + type + ']', message);
}

function initModalAccessibility() {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    $(document).on('show.bs.modal', '.modal', function () {
        $(this).data('modal-trigger', document.activeElement);
    });

    $(document).on('shown.bs.modal', '.modal', function () {
        var $modal = $(this);
        var $focusable = $modal.find(FOCUSABLE).filter(':visible');
        var $formElements = $focusable.not('.close, [data-dismiss="modal"]');

        var title = $modal.find('.modal-title').first().text().trim();
        setAccessibilityLiveRegionMessage((title ? title + ': ' : '') + 'Fenster geöffnet', 'assertive');

        if ($formElements.length > 0) {
            $formElements.first().focus();
        } else {
            $focusable.first().focus();
        }

        $modal.on('keydown.modalTrap', function (e) {
            if (e.key !== 'Tab') return;
            var $items = $modal.find(FOCUSABLE).filter(':visible');
            var first = $items.first()[0];
            var last = $items.last()[0];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });
    });

    $(document).on('hidden.bs.modal', '.modal', function () {
        $(this).off('keydown.modalTrap');
        setAccessibilityLiveRegionMessage('Fenster geschlossen');
        var trigger = $(this).data('modal-trigger');
        if (trigger && typeof trigger.focus === 'function') {
            trigger.focus();
        }
    });
}

$(document).ready(function () {
    initModalAccessibility();

    if($('#cookie-consent-wrapper').length > 0){
        var heightCookiebar = $('#cookie-consent-wrapper').outerHeight();
        $('body').css('padding-bottom',heightCookiebar);

        $('#cookie-consent-button').on('click',function(){
            $('body').css('padding-bottom','');
        });
    }
    $(document).on('click', '.itemcard_order_submit_button', function () {
        if (!$(this).is(':disabled')) {
            var label = $(this).find('span').text().trim() || $(this).text().trim();
            var qty = $(this).closest('.itemcard_order_button_input_wrapper_outer').find('input[type="number"]').val()
                   || $(this).closest('form').find('.input_item_quantity_value').val();
            setAccessibilityLiveRegionMessage(qty ? label + ': ' + qty : label);
        }
    });

    $('.itemlist_order_button_link').on('click',function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!$(this).is(':disabled')) {

            var parser = document.createElement('a');
            parser.href = window.location.href;

            var search = parser.search;
            search = search.replace('?action=shop_add_item_to_basket_list', '').replace('&action=shop_add_item_to_basket_list', '');

            var formAction = '?';
            if (search != '') {
                formAction = search + '&'
            }

            formAction += "action=shop_add_item_to_basket_list";
            $('<input>').attr({
                type: 'hidden',
                id: 'item_qty',
                name: 'item_qty',
                value: $(this).closest('form').find('.input_item_quantity_value').val()
            }).appendTo($(this).closest('form'));
            $('<input>').attr({
                type: 'hidden',
                id: 'item_id',
                name: 'item_id',
                value: $(this).closest('form').find('.input_item_id').val()
            }).appendTo($(this).closest('form'));
            $(this).closest('form').attr("action", formAction);
            var qty = $(this).closest('form').find('.input_item_quantity_value').val();
            var label = $(this).text().trim();
            setAccessibilityLiveRegionMessage(qty ? label + ': ' + qty : label);
            $(this).closest('form').submit();
        }
    });

    /*$( "#input_vatid" ).blur(function() {
        if ($(this).val() != '' && $('#selectedReverseChargeAllowed').val() == 1) {
            var result = jsvat.checkVAT($(this).val());
            if (!result.isValid) {
                $(this).parent().addClass('has-danger');
            } else {
                $(this).parent().removeClass('has-danger');
            }
        } else {
            if ($(this).parent().hasClass('has-danger')) {
                $(this).parent().removeClass('has-danger');
            }
        }
    });

    $('.required').each(function(e) {
        var input = $(this).find('input');
        if (input.is(':visible')) {
            input.blur(function() {
                if (input.val() == '') {
                    input.parent().addClass('has-danger');
                } else {
                    input.parent().removeClass('has-danger');
                }
            })
        }
    });

    $('body').on('click',".validate_vat",function(e) {
        e.preventDefault();
        var error = false;
        if ($( "#input_vatid" ).val() != '' && $('#selectedReverseChargeAllowed').val() == 1) {
            var result = jsvat.checkVAT($( "#input_vatid" ).val());
            if (!result.isValid) {
                $(this).parent().addClass('has-danger');
                error = true;
            } else {
                $(this).parent().removeClass('has-danger');
            }
        } else {
            if ($(this).parent().hasClass('has-danger')) {
                $(this).parent().removeClass('has-danger');
            }
        }

        $('.required').each(function(e) {
            var input = $(this).find('input');
            if (input.is(':visible')) {
                if (input.val() == '') {
                    error = true;
                    input.parent().addClass('has-danger');
                }
            }
        });

        if (!error) {
            document.form_user_order.action='?shop_category=order&action=step2';
            document.form_user_order.submit();
        } else {
            $('#vat_check_requestbox').modal('show');
        }
        return false;
    }); */

    // Payment/shipping radio cards: full keyboard control
    $('body').on('keydown', '.order_option_list .form-check[tabindex]', function (e) {
        var $card = $(this);
        var $allCards = $card.closest('.order_option_list').find('.form-check[tabindex]');
        var idx = $allCards.index($card);

        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            var $radio = $card.find('input[type="radio"]');
            $radio.prop('checked', true);
            $radio[0].form.submit();
        }
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            $allCards.eq((idx + 1) % $allCards.length).focus();
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            $allCards.eq((idx - 1 + $allCards.length) % $allCards.length).focus();
        }
    });

    $('body').on('click', '.order_option_list .form-check[tabindex]', function () {
        var $radio = $(this).find('input[type="radio"]');
        $radio.prop('checked', true);
        $radio[0].form.submit();
    });

    $('body').on('click', '.video-select', function (e) {
        e.preventDefault;
        videoPath = $(this).attr('data-videoPath');
        videoName = $(this).attr('data-videoName');
        videoId = $(this).attr('data-videoId');
        $('.mcs-item').each(function(e) {
            $(this).find('a').removeClass('mz-thumb-selected');
        });
        $('.item_video_container').removeClass('active');
        $('.item_video_container').find('.video_container').hide();
        $(this).addClass('mz-thumb-selected');
        $('#video_' + videoId).show();
        $('#video_' + videoId).parents('.item_video_container').addClass('active');
        return false;
    });
    $('body').on('click', '.mz-thumb', function (e) {
        e.preventDefault;
        if($(e.target).is('.video-select') || $(e.target).parent().is('.video-select')) {
            return;
        }
        $('.mcs-item').each(function(e) {
            $(this).find('a').removeClass('mz-thumb-selected');
        });
        $(this).addClass('mz-thumb-selected');
        $('.item_video_container').removeClass('active');
        $('.item_video_container').find('.video_container').hide();
    });


    $('#box,.user_account_link,#header_basket,.language_switch,.stickyBoxes').hoverIntent(config);
    $('#primary_navigation li.level_1').hoverIntent(configPrimary);


    $('.itemcard_list').not('.itemcard_list3').find('.itemlist').find('.itemlist_container').hoverIntent(configItemlist);
    $('.itemcard_list3').find('.itemlist').find('.itemlist_container').hoverIntent(configItemlistNoExt);

    var noOfImg = $('#menu_1 div.itemlist11>a>img').length,
        loadedImg = 0;

    $('#menu_1 div.itemlist11>a>img').on('load', function () {
        ++loadedImg;
        if (loadedImg == noOfImg) {
            $('#menu_1 div.itemlist11>a>img').each(function () {
                var pic = $(this),
                    picHeight = $(this).outerHeight(),
                    par = $(pic).parents('a'),
                    parHeight = $(par).height(),
                    margin = Math.ceil((parHeight - picHeight) / 2);
                console.log('picHeight:' + picHeight + ' parHeight:' + parHeight + ' margin:' + margin);
                $(pic).css('margin-top', margin + 'px');
            });
        }
    });

    stickyHeader();

    $('#primary_navigation > ul > li,.stickyBoxes').hoverIntent(config);

    $('.toggle_navigation, #primary_navigation_mobile .close_button_navigation_mobile, #overlay').click(function () {
        toggle_mobile_menu();
    });

    $(document).on('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && $('#primary_navigation_mobile').hasClass('active')) {
            hide_mobile_menu();
        }
    });

    $('#primary_navigation_mobile li').each(function () {
        if($(this).children('ul').length > 0){
            $(this).children('a').append('<button type="button" class="toggleSubnavi" aria-label="Untermenü öffnen" aria-expanded="false"><i class="icon icon-angle-right" aria-hidden="true"></i></button>');
            $(this).addClass('hasChildren');
        }
    });

    $('#primary_navigation_mobile .navigation > ul > li').each(function () {
        if($(this).children('.navigationHover').length > 0){
            $(this).children('a').append('<button type="button" class="toggleSubnavi" aria-label="Untermenü öffnen" aria-expanded="false"><i class="icon icon-angle-right" aria-hidden="true"></i></button>');
            $(this).addClass('hasChildren');
        }
    });

    $(document).on('click','#primary_navigation_mobile .toggleSubnavi',function (event) {
        var nextUl = $(this).parent().next('ul');
        if(!nextUl.length){
            nextUl = $(this).parent().next('.navigationHover');
        }
        if (nextUl.is(':visible')) {
            nextUl.slideUp('fast');
            $(this).attr('aria-expanded', 'false').attr('aria-label', 'Untermenü öffnen');
            $(this).parent().removeClass('active_tree');
            $(this).closest('li').removeClass('active_tree');
            nextUl.find('.active_tree').removeClass('active_tree');
            nextUl.find('ul').slideUp('fast');
        } else {
            nextUl.slideDown('fast');
            $(this).attr('aria-expanded', 'true').attr('aria-label', 'Untermenü schließen');
            $(this).parent().addClass('active_tree');
            $(this).closest('li').addClass('active_tree');
        }
        event.preventDefault();
    });

    $('.filterbox-mobilebutton').click(function () {
        var expanded = $(this).attr('aria-expanded') === 'true';
        $(this).toggleClass('active').attr('aria-expanded', expanded ? 'false' : 'true');
        $('.filterbox').slideToggle('fast');
    })

    $(document).on('keydown', '.filter_unset a', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            window.location.href = $(this).attr('href');
        }
    });

    // Variant selector keyboard navigation
    $(document).on('keydown', '.select_body_header', function (e) {
        var $trigger  = $(this);
        var $listbox  = $('#' + $trigger.attr('aria-controls'));
        var $options  = $listbox.find('a[role="option"]');

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if ($trigger.attr('aria-expanded') === 'false') {
                toggle($listbox.attr('id'));
            }
            $options.first().focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if ($trigger.attr('aria-expanded') === 'false') {
                toggle($listbox.attr('id'));
            }
            $options.last().focus();
        } else if (e.key === 'Escape') {
            if ($trigger.attr('aria-expanded') === 'true') {
                toggle($listbox.attr('id'));
            }
            $trigger.focus();
        }
    });

    $(document).on('keydown', '.select_body_options a[role="option"]', function (e) {
        var $option   = $(this);
        var $listbox  = $option.closest('.select_body_options');
        var $trigger  = $('[aria-controls="' + $listbox.attr('id') + '"]');
        var $options  = $listbox.find('a[role="option"]');
        var index     = $options.index($option);

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            var $next = $options.eq(index + 1);
            ($next.length ? $next : $options.first()).focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (index === 0) {
                toggle($listbox.attr('id'));
                $trigger.focus();
            } else {
                $options.eq(index - 1).focus();
            }
        } else if (e.key === 'Escape') {
            toggle($listbox.attr('id'));
            $trigger.focus();
        } else if (e.key === 'Tab') {
            if ($trigger.attr('aria-expanded') === 'true') {
                toggle($listbox.attr('id'));
            }
        }
    });

    function getFilterGroupName($el) {
        return $el.closest('.filter-wrapper-inner').find('.filterbox_headline .h3').text().trim()
            || $el.closest('.filter-wrapper-inner').find('.filter_headline').first().text().trim();
    }

    // List filter (type 0): <ul class="filterlist"><li><a href>
    $(document).on('click', '.filterlist li a', function () {
        var value = $(this).text().trim();
        setAccessibilityLiveRegionMessage(getFilterGroupName($(this)) + ': ' + value);
    });

    // Scroll list / Dropdown filter (type 1/2): <select class="filterlist" onchange>
    $(document).on('change', 'select.filterlist', function () {
        var value = $(this).find('option:selected').text().trim();
        setAccessibilityLiveRegionMessage(getFilterGroupName($(this)) + ': ' + value);
    });

    // Icons filter (type 5): <a> directly in .filter_body.icons_body
    $(document).on('click', '.filter_body.icons_body a', function () {
        var value = $(this).find('img').attr('alt') || $(this).text().trim();
        setAccessibilityLiveRegionMessage(getFilterGroupName($(this)) + ': ' + value);
    });

    // Checkbox filter (type 4): <label onclick="window.location.href=...">
    $(document).on('click', '.filter.checkboxes .form-check-label', function () {
        var value = $(this).text().trim();
        setAccessibilityLiveRegionMessage(getFilterGroupName($(this)) + ': ' + value);
    });

    $(document).on('click', '.filter_unset a', function () {
        setAccessibilityLiveRegionMessage(getFilterGroupName($(this)) + ': Filter entfernt');
    });

    $('.filter > .filter_headline').click(function () {
        var active = $(this).hasClass('clicked');

        $('.filterbox .filter_headline').removeClass('clicked').attr('aria-expanded', 'false');
        $('.filterbox .filter_toggle').slideUp('fast');

        if (active != false) {
            $(this).removeClass('clicked').attr('aria-expanded', 'false');
            $(this).next('.filter_toggle').slideUp('fast');
        } else {
            $(this).addClass('clicked').attr('aria-expanded', 'true');
            $(this).next('.filter_toggle').slideDown('fast');
        }
    });

    if ($('.shop_item_preview > .owl-carousel').length > 0) {
        $('.shop_item_preview > .owl-carousel').each(function(){
            if($(this).closest('.itempreviewnoslider').length > 0 && $(window).width() > 767){
                $(this).removeClass('owl-carousel');
            }else{
                $(this).closest('.itempreviewnoslider').removeClass('itempreviewnoslider');
                if(!$(this).closest('#user_queue').length) {
                    $(this).owlCarousel({
                        loop: true,
                        items: 5,
                        margin: 20,
                        autoplay: true,
                        autoHeight: true,
                        autoWidth: false,
                        navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-angle-right"></i>'],
                        nav: true,
                        autoplayHoverPause: true,
                        onInitialized: initHoverintentItemlistOwl,
                        responsive: {
                            0: {
                                items: 2,
                                center: false,
                                nav: false,
                                margin: 0,
                                autoWidth: true
                            },
                            481: {
                                items: 2,
                                autoWidth: false
                            },
                            768: {
                                items: 3
                            },
                            1024: {
                                items: 4
                            },
                            1540: {
                                items: 5
                            }
                        }
                    });
                }
            }
        });
    }

    $('.itemlist_variants_wrapper').each(function (i) {
        var childrenCount = $(this).children('.variant_image').length;
        variant_slider_array[i] = $(this).bxSlider({
            mode: 'vertical',
            pager: false,
            autoReload: true,
            controls: false,
            slideMargin: 5,
            maxSlides: 3,
            minSlides: 3,
            adaptiveHeight: true
        });
        $(this).parents('.itemlist_variants').find('.variant-next').on('click', function(e) {
            e.preventDefault();
            variant_slider_array[i].goToNextSlide();
        });
        $(this).parents('.itemlist_variants').find('.variant-prev').on('click', function(e) {
            e.preventDefault();
            variant_slider_array[i].goToPrevSlide();
        });
        if (childrenCount < 4) {
            $(this).parents('.itemlist_variants').find('.variant-next').hide();
            $(this).parents('.itemlist_variants').find('.variant-prev').hide();
        }
    });

    $('.input_quantity_line').keydown(function (event) {
        if (event.keyCode == 13) {
            this.form.submit();
            return false;
        }
    });

    $(document).on('change', '.input_quantity_line', function () {
        var label = $('label[for="' + $(this).attr('id') + '"]').text().trim();
        setAccessibilityLiveRegionMessage(label ? label + ': ' + $(this).val() : $(this).val());
    });

    $('.textcontent table').wrap('<div class=\"table_wrapper\"></div>');

    $('.item-details-content table').wrap('<div class=\"table_wrapper\"></div>');


    var mainImage;
    var mainActive;
    $( ".itemlist_variants_wrapper" ).on("mouseenter", ".variant_image",
        function(e) {
            variantImage = $(this);
            mainActive = variantImage.parent().find('.main_active');
            if (!variantImage.hasClass('active')) {
                mainImage = $(this).parents('.itemlist_container').find('.itemlist_item a .image img');
                /*mainImage.clearQueue().fadeTo(300,0.00, function() {
                    mainImage.attr("src",variantImage.find('img').data('big'));
                }).fadeTo(300,1);*/
                mainImage.attr("src",variantImage.find('img').data('big'));
                variantImage.parent().find('.variant_image').removeClass('active');
                variantImage.addClass('active');
            }
            return false;


            //mainImage.attr('src',$(this).find('img').data('big'));
        }
    );

    $( ".itemlist_variants_wrapper" ).on("mouseleave", function() {
        if (!mainActive.hasClass('active')) {
            /*mainImage.clearQueue().fadeTo(300,0.00, function() {
                mainImage.attr("src",mainImage.data('main'));
            }).fadeTo(300,1);*/
            mainImage.attr("src",mainImage.data('main'));
            $(this).find('.variant_image').removeClass('active');
            mainActive.addClass('active');
        }
        return false;
        //mainImage.attr('src',mainImage.data('main'));
    });

    var visibleInputs = $('input[type!=hidden]:visible'),
        inputForm,
        currInput,
        lastInputInForm;
    $(visibleInputs).each(function () {
        currInput = $(this);
        inputForm = currInput.parents('form');
        formID = $(inputForm).attr('id');
        if (formID !== 'form_itemcard') {
            lastInputInForm = $(inputForm).find('input[type!=hidden]:visible').last();
            lastTextInputInForm = $(inputForm).find('input[type!=checkbox]:visible').last();
            if ((currInput[0] == lastInputInForm[0]) || (currInput[0] == lastTextInputInForm[0])) {
                $(currInput).off('keyup').on('keyup', function (e) {
                    if (e.which === 13) {
                        //e.preventDefault();
                        //e.stopPropagation();
                        //$(this).parents('form').submit();
                        return false;
                    }
                });
            }
        }
    });

    //Toggle variants
    $('.hasvar td:first-child').on('click', function () {
        var parentTr = $(this).parent('.hasvar'),
            itemNo = parentTr[0].dataset.itemno,
            varTrs,
            initStringEl = $(parentTr).find('.replace_price_string_toggle'),
            initString,
            replacementString,
            i = 0;

        if (typeof initStringEl !== 'undefined' && initStringEl.length > 0) {
            initString = $(initStringEl).data('initstring');
            replacementString = $(initStringEl).data('replacementstring');
        }

        if (typeof itemNo !== 'undefined' && itemNo.length > 0) {
            varTrs = $('.isvar_' + itemNo);
            varTrscol = $('.iscolorvar_' + itemNo);
            if (typeof varTrs !== 'undefined' && varTrs.length > 0) {
                i = 0;
                $(varTrs).each(function () {
                    if ($(this).is(':visible')) {
                        $(this).hide();
                        if (i == 0) {
                            $(parentTr).removeClass('varsopen').addClass('varsclosed');
                            if (initString.length > 0 && replacementString.length > 0) {
                                $(initStringEl).empty().html(initString);
                            }
                        }

                    } else {
                        $(this).show();
                        if (i == 0) {
                            $(parentTr).removeClass('varsclosed').addClass('varsopen');
                            if (initString.length > 0 && replacementString.length > 0) {
                                $(initStringEl).empty().html(replacementString);
                            }
                        }
                    }
                    i++;
                });
            }
            if (typeof varTrscol !== 'undefined' && varTrscol.length > 0) {
                $(varTrscol).each(function () {
                    if ($(this).is(':visible')) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                });
            }
        }
    });

    if ($('#search_data').length) {
        var queryDelay = 300,
            queryTimeout;

        $('#input_search').on('keyup', function (e) {
            queryString = $('#input_search').val();
            if (queryTimeout) {
                window.clearTimeout(queryTimeout);
                queryTimeout = null;
            }
            if (e.keyCode != 13 && e.keyCode != 40 && e.keyCode != 38 && e.keyCode != 8 && queryString.length > 3) {
                queryTimeout = window.setTimeout(function () {
                    itemsearchSuggest(queryString);
                }, queryDelay);
            }
        });

        $('html').on('click', function () {
            //hide elements if visible
            var searchSuggestWrapper = $('#itemsearch_suggestion_wrapper');

            if (typeof searchSuggestWrapper !== 'undefined' && $(searchSuggestWrapper).is(':visible')) {
                $(searchSuggestWrapper).empty().hide();
            }
        });

        $('#itemsearch_suggestion_wrapper,#form_search').on('click', function (event) {
            event.stopPropagation();
        });
    }

    $('.searchForm__label').on('click', function () {
        var form = $(this).closest('.searchForm');
        var wrapper = form.find('.searchForm__inputWrapper');
        var isActive = form.hasClass('active');
        form.toggleClass('active');
        if (isActive) {
            $(this).attr('aria-expanded', 'false');
            wrapper.prop('inert', true);
        } else {
            $(this).attr('aria-expanded', 'true');
            wrapper.prop('inert', false);
            wrapper.find('input').focus();
        }
    });

    $(document).on('click', function (e) {
        var target = $(e.target);
        if (target.closest('.searchForm').length === 0) {
            $('.searchForm').removeClass('active');
            $('.searchForm__label').attr('aria-expanded', 'false');
            $('.searchForm__inputWrapper').prop('inert', true);
        }
    });

    $('.bannerBordered .banner__image').each(function () {
        var img = $(this).find('img');

        if(img.length > 0){
            var imgSrc = img.attr('src');
            $(this).css('background-image','url('+imgSrc+')');
        }
    });

    fixRemoveEmptyCollections();

    $('.stickyBoxes__icon').on('mouseover',function () {
        $('.stickyBoxes__icon').removeClass('active');
        $(this).addClass('active');
        showBoxContent($(this).index());
    });

    $('.stickyBoxes__icon').on('click',function () {
        $('.stickyBoxes__icon').removeClass('active');
        $(this).addClass('active');
        showBoxContent($(this).index());
    });

    $('.toggleTable').click(function (e) {
        if($(event.target).attr('class') !== "button")  {
            $(this).find('.toggleTableRow:not(.isfirst)').slideToggle('fast');
            $(this).toggleClass('active');
        }
    });

    setSrcVideos();

    var activeFilterMessages = [];
    $('.filterbox .filter-wrapper-inner').each(function () {
        var $wrapper = $(this);
        var groupName = $wrapper.find('.filterbox_headline .h3').text().trim();
        var $activeItem = $wrapper.find('.filterlist li[data-isset="true"] span');
        if ($activeItem.length > 0) {
            var value = $activeItem.text().trim();
            if (groupName && value) {
                activeFilterMessages.push(groupName + ': ' + value);
            }
        } else {
            var $activeHeadline = $wrapper.find('.filter_headline.active');
            if ($activeHeadline.length > 0) {
                var headlineText = $activeHeadline.text().trim();
                if (headlineText) {
                    activeFilterMessages.push(headlineText);
                }
            }
        }
    });
    if (activeFilterMessages.length > 0) {
        setAccessibilityLiveRegionMessage('Aktive Filter: ' + activeFilterMessages.join(', '));
    }

    var politeMessages = [];
    var assertiveMessages = [];
    $('#flashMessages .flashMessage').each(function () {
        var $clone = $(this).clone();
        $clone.find('i').remove();
        var msg = $clone.text().trim();
        if (msg) {
            if ($(this).hasClass('flashMessage_error')) {
                assertiveMessages.push(msg);
            } else {
                politeMessages.push(msg);
            }
        }
    });
    if (politeMessages.length > 0) {
        setAccessibilityLiveRegionMessage(politeMessages.join('. '));
    }
    if (assertiveMessages.length > 0) {
        setAccessibilityLiveRegionMessage(assertiveMessages.join('. '), 'assertive');
    }
});

$(document).ready(function() {

    $('input.inputfile').change(function () {
        var file = $(this).val().split('\\').pop();

        if (file == '') {
            var data_files = $(this).prop('data-files');
            file = data_files[0].name;
            $(this).attr('value', file);
        }
        if ($(this).get(0).files.length > 1){
            file = $(this).get(0).files.length + ' ' + tc_more_files;
        }
        var id = $(this).attr('id');
        $('label[for="' + id + '"]').addClass('active');
        $('label[for="' + id + '"]').children('span').empty().append(file);
    });

    $(document).on('click','.magicZoomAchors',function(){
       var slideID = $(this).data('slideId');
       $('.zoom-gallery-slide').removeClass('active');
       $('.zoom-gallery-slide[data-slide-id="'+slideID+'"]').addClass('active');
    });

    // Accessibility: MagicZoom generated images are decorative — set alt=""
    $('.mz-lens img, .mz-zoom-window img').attr('alt', '');

    // Accessibility: label mz-figure from the product image alt text
    function labelMzFigures(root) {
        $(root).find('.mz-figure').addBack('.mz-figure').each(function () {
            if (!$(this).attr('aria-label')) {
                var alt = $(this).find('img[alt]').first().attr('alt');
                if (alt) { $(this).attr('aria-label', alt); }
            }
        });
    }
    labelMzFigures(document);

    new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    $(node).find('.mz-lens img, .mz-zoom-window img').attr('alt', '');
                    labelMzFigures(node);
                }
            });
        });
    }).observe(document.body, { childList: true, subtree: true });
});



function sendNewsletterForm(sitepartId) {
    var container = $("#select_nl_segment_" + sitepartId);

    var valueString = "";

    container.find("input[type=checkbox]:checked").each(function(i, ele) {
        var val = $(ele).data("value");
        valueString += val + ",";
    });

    valueString = valueString.substring(0,valueString.length-1);

    $("#selected_segment_" + sitepartId).val(valueString);
    $("#newsletter_registration_" + sitepartId).submit();
}

function openNewsletterSegmentModal(sitepartId) {
    $("#lightbox_newsletter_segment_" + sitepartId).modal("show");
}

//triggers on click on any links that start with # --> meaning they are scrollmarks and no new pages
// and smoothly scroll to it. the scrollTop value is a calculation that includes the sticky header
$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    if ($(this).parents('.modal').length > 0) {
        return;
    }
    if ($(this).attr('href') == "#") {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    } else {
        var header = $('.header');
        var headerHeight = 0;
        if(header.length > 0){
            headerHeight = header.outerHeight();
        }
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - headerHeight
        }, 500);
    }
});